import type { APIEvents } from '../enums/api-events';

/**
 * Dispatches a custom event with the specified name and details.
 * @template T
 * @param eventName - The name of the custom event to dispatch.
 * @param payload - The details to attach to the custom event.
 */
export function sendCustomEvent<T>(eventName: APIEvents, payload?: T): void {
  if (typeof document === 'undefined') {
    return;
  }

  const event = new CustomEvent(eventName, { detail: payload });
  document.dispatchEvent(event);
}
